<template>
    <v-container>

        <CustomHeading
                :breadcrumbs="breadcrumbs"
        />

        <v-row>
            <v-col cols="12" md="9">
                <v-card elevation="2">
                    <v-container>
                        <v-row>
                            <v-col class="d-flex justify-center">
                                <h2 class="primary--text pb-2">
                                    <v-icon class="mb-1" color="primary" left>mdi-clipboard-account</v-icon>
                                    Osnovni Podaci
                                </h2>
                            </v-col>
                        </v-row>
                        <div style="height: 1px; background: linear-gradient(90deg,#fff,#084776,#fff);"></div>
                        <v-row v-for="(value, key, index) in employeeInfo" :key="index">
                            <v-col class="d-flex align-end flex-column" cols="4">
                                <p class="font-weight-bold text-right">{{ key }}:</p>
                            </v-col>
                            <v-col cols="8">
                                <p>{{ value ? value : '-' }}</p>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>

                <v-card elevation="2" class="mt-3">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <h3 class="primary--text text-center">Uloge koje korisnik ima u obrazovnoj instituciji</h3>
                                <div  class="mt-2 " style="height: 1px; background: linear-gradient(90deg,#fff,#084776,#fff);"></div>
                                <v-expansion-panels class="mt-4">
                                    <v-expansion-panel v-for="item in userModelRoles" :key="item.id" :disabled="(item.role_id !== 6)">
                                        <v-expansion-panel-header class="px-3 px-sm-6">
                                            <v-list-item class="pa-0">
                                                <v-list-item-action>
                                                    <v-icon color="primary">mdi-lock</v-icon>
                                                </v-list-item-action>

                                                <v-list-item-content>
                                                    <v-list-item-title>{{item.role_title}}</v-list-item-title>
                                                    <v-list-item-subtitle>{{item.organisation.name}}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content v-if="item.role_id === 6">
                                            <div>
                                                <h3 class="mb-4">Popis predmeta</h3>
                                                <span class="mr-2" v-for="subject in item.subjects" :key="subject.id">
                                                    <v-chip 
                                                        class="mb-2"
                                                        close
                                                        @click:close="openDeleteSubject(subject.pivot.id)"
                                                    >
                                                        {{subject.title}}
                                                    </v-chip>
                                                </span>
                                                <span>
                                                    <v-chip class="mb-2 primary" @click="openAddSubject(item)" style="cursor: pointer;">
                                                        <v-icon color="white" size="16px">mdi-plus</v-icon>
                                                    </v-chip>
                                                </span>
                                            </div>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
            <v-col cols="12" md="3" class="fix-element">
              <div v-if="$getUser().id == $route.params.djelatnik_id">
                <v-btn v-if="$getUser().has_identity" dark depressed class="mb-4 text-none" height="50px" color="red" block
                       @click="passwordReset()">
                  <img height="25px" class="pr-4" src="../../assets/img/eduID-white.svg"/>Promjena lozinke
                </v-btn>
                <v-btn v-if="$checkPermission('user roles edit')" class="mt-4 custom-btn-blue text-none mb-4" height="50px" color="primary"
                       @click="showUserRolesDialog()" block
                       outlined>
                  <v-icon color="primary" left>mdi-lock</v-icon>
                  Dodijeli ulogu
                </v-btn>
                <v-btn v-if="$checkPermission('users edit')" color="primary" class="text-none" height="50px" @click="showAddForm()" block>
                  <v-icon color="white" left>mdi-pencil</v-icon>
                  Uredi podatke
                </v-btn>
                <!--Dodati mogucnost za brisanje skole-->
                <v-btn v-if="$checkPermission('users delete')" class="mt-4 custom-btn-red text-none" height="50px" color="red" @click="deleteItem()" block
                       outlined>
                  <v-icon color="red" left>mdi-delete</v-icon>
                  Obriši djelatnika
                </v-btn>
              </div>
              <div v-else>
                <v-btn v-if="!has_identity" dark depressed class="mb-4 text-none" height="50px" color="red" block
                       @click="dialog = true">
                    <img height="25px" class="pr-4" src="../../assets/img/eduID-white.svg"/>Dodijeli eduID
                    identitet
                </v-btn>
                <v-btn v-else dark depressed class="mb-4 text-none" height="50px" color="red" block
                       @click="passwordReset()">
                    <img height="25px" class="pr-4" src="../../assets/img/eduID-white.svg"/>Promjena lozinke
                </v-btn>
                <v-btn v-if="$checkPermission('user roles edit')" class="mt-4 custom-btn-blue text-none mb-4" height="50px" color="primary"
                       @click="showUserRolesDialog()" block
                       outlined>
                    <v-icon color="primary" left>mdi-lock</v-icon>
                    Uredi ulogu
                </v-btn>
                <v-btn v-if="$checkPermission('users edit')" color="primary" class="text-none" height="50px" @click="showAddForm()" block>
                    <v-icon color="white" left>mdi-pencil</v-icon>
                    Uredi podatke
                </v-btn>
                <!--Dodati mogucnost za brisanje skole-->
<!--                <v-btn v-if="$checkPermission('users delete')" class="mt-4 custom-btn-red text-none" height="50px" color="red" @click="deleteItem()" block-->
<!--                       outlined>-->
<!--                    <v-icon color="red" left>mdi-delete</v-icon>-->
<!--                    Obriši djelatnika-->
<!--                </v-btn>-->
              </div>
            </v-col>
        </v-row>
        <v-dialog
                v-model="dialog"
                width="500">

            <v-card>
                <v-card-title
                        primary-title>
                    <v-icon left>mdi-key</v-icon>
                    Dodijeli eduID identitet
                </v-card-title>

                <v-card-text style="padding-top: 20px;">
                    <!--{{ deleteText }}-->
                    <!--<v-text-field v-model="password" outlined label="Unesite novu lozinku" @click:append="show1 = !show1" hide-details :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'"></v-text-field>-->
                    <!--<div v-if="password">-->
                    <!--<span class="font-weight-grey">Nova lozinka: </span>-->
                    <!--<span class="font-weight-bold">{{password}}</span>-->
                    <!--</div>-->

                    <v-checkbox
                            v-model="checkbox"
                            label="Pošalji na mail?"
                            color="primary"
                    ></v-checkbox>
                    <v-text-field v-if="checkbox" v-model="email" label="Privatni email" outlined></v-text-field>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialog = false" depressed large outlined>Odustani</v-btn>
                    <v-btn @click="giveIdentity()" color="primary" :loading="loading" :class="loading ? 'disable-events' : ''" depressed large>Dodijeli identitet</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="addDialog"
            width="400"
        >
            <v-card>
                <v-card-title
                        primary-title>
                    Dodaj predmet
                </v-card-title>

                <v-card-text class="my-4">
                    <v-autocomplete
                        :items="filteredEmployeeSubjects"
                        placeholder="Odaberite predmet"
                        item-text="title"
                        item-value="id"
                        v-model="subjectId"
                        height="44"
                        dense
                        hide-details
                        outlined
                    ></v-autocomplete>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="addDialog = false" depressed large outlined>Odustani</v-btn>
                    <v-btn @click="addTeacherSubject" color="primary" depressed large>Potvrdi</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="deleteDialog"
            width="500">

            <v-card>
                <v-card-title
                        primary-title>
                    {{ dialogTitle }}
                </v-card-title>

                <v-card-text style="padding-top: 20px;">
                    {{ deleteText }}
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="deleteDialog = false" depressed large outlined>Odustani</v-btn>
                    <v-btn @click="deleteEmployeeSubject" color="error" depressed large>Izbriši</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <reset-password></reset-password>
        <user-roles-dialog></user-roles-dialog>
    </v-container>
</template>

<script>
    import CustomHeading from '../heading/CustomHeading'
    import ResetPassword from '../dialogs/ResetPassword'
    import {serverBus} from "../../main";
    import UserRolesDialog from "../dialogs/UserRolesDialog";
    import ApiV2 from '../../services/ApiV2'

    export default {
        components: {
            UserRolesDialog,
            CustomHeading,
            ResetPassword,
        },

        computed: {
            birthCountry() {
                return this.$store.getters.getCountryByValue(this.user.country_of_birth)
            },

            filteredEmployeeSubjects() {
                if(this.employeeSubjects) {
                    let ids = this.employeeSubjects.map(subject => subject.id);
                    return this.subjects.filter(item => ids.indexOf(item.id) === -1);
                } else {
                    return this.subjects;
                }
            },
        },
        data() {
            return {
                breadcrumbs: [
                    {text: 'Administracija'},
                    {text: 'E-matica'},
                    {text: 'Djelatnici', href:'/admin/djelatnik'}
                ],
                has_identity: null,
                email: '',
                employeeInfo: {},
                //Activities nadodati kada bude spreman api
                activities: [],
                user: [],
                dropdownItems: [],
                roles_user: [],
                logged_user: false,
                subjectId: null,
                employeeSubjects: [],
                currentRoleModelId: null,
                teacherSubjectId: null,
                subjects: [],
                organisationTypes: [
                    {value: 'Canton', text: 'Županija'},
                    {value: 'School', text: 'Škola'},
                    {value: 'Department', text: 'Odjeljenje'}
                ],
                schools: [],
                cantons: [],
                first_name: '',
                last_name: '',
                dialog: false,
                checkbox: false,
                loading: false,
                addDialog: false,
                deleteDialog: false,
                userModelRoles: [],
                deleteText: 'Operacija koju ste zatražili može imati za posljedicu gubitak određenog dijela podataka. Jeste li sigurni da želite izbrisati odabrani resurs?',
                dialogTitle: 'Jeste li sigurni?',
            }
        },
        created: function () {
            this.logged_user = this.$getUser().id == this.$route.params.djelatnik_id ? true : false

            var employeeId = this.$route.params.djelatnik_id
            let table = 'djelatnik' + '/' + `${employeeId}`;
            this.$store.commit('setTable', table);

            this.$store.dispatch("getCountries");

            this.$axios.post('djelatnik/' + `${employeeId}`).then(response => {
                this.breadcrumbs.push({text: response.data.first_name + ' ' + response.data.last_name})
            });

            this.$axios.post('ostalo/uloga/options').then(response => {
                this.schools = response.data.schools;
                this.cantons = response.data.cantons;
            });

            serverBus.$on('refresh-employee-profile', () => {
                this.getUserRoles();
            });

            this.getData();
            this.getUserRoles();
            this.getSubjects();

            serverBus.$on('show-employee-add-form', () => {
                this.$router.push({
                    name: 'EmployeeAddView',
                    params: {table: 'djelatnik', resource_id: `${employeeId}`}
                });
            });
        },

        watch: {
            birthCountry: function (newVal) {
                this.employeeInfo['Država rođenja'] == newVal.text
            }
        },

        methods: {
            openAddSubject(item) {
                this.addDialog = true; 
                this.currentRoleModelId = item.id;
                this.subjectId = null;

                if(item.role_id === 6) {
                    this.employeeSubjects = item.subjects;
                }
            },

            openDeleteSubject(subjectId) {
                this.teacherSubjectId = subjectId;
                this.deleteDialog = true;
            },

            showAddForm: function () {
                serverBus.$emit('show-employee-add-form', {id: this.$route.params.djelatnik_id});
            },

            passwordReset() {
                serverBus.$emit('show-reset-password-dialog', 'djelatnik', {id: this.$route.params.djelatnik_id}, this.email, this.first_name, this.last_name, this.logged_user);
            },

            showUserRolesDialog() {
                // console.log(this.user)
                serverBus.$emit('show-user-roles-dialog', this.user);
            },

            giveIdentity() {
                this.loading = true
                let reqBody = {}
                if (this.checkbox) {
                    reqBody.email = this.email
                }
                this.$axios.post('/sso/identity/' + this.$route.params.djelatnik_id, reqBody)
                    .then(response => {
                        // console.log(response.data)
                        let user = response.data
                        let email = user.email
                        let password = user.password
                        // serverBus.$emit('give-identity-for-user', email, password);
                        this.$router.push({
                            name: 'Print',
                            query: {email: email, password: password},
                            params: {table: 'print', resource_id: this.$route.params.djelatnik_id}
                        });
                    }).catch(function () {
                    serverBus.$emit('show-snackbar', false, 'Nemoguće dodijeliti identitet!!');
                    })
                    .finally(() => {
                        this.loading = false;
                    });

            },

            addTeacherSubject() {
                ApiV2.post('teacher_subjects', {
                    model_has_role_id: this.currentRoleModelId,
                    subject_id: this.subjectId
                }).then(() => {
                    this.addDialog = false;
                    this.getData();
                    serverBus.$emit('show-snackbar', true, `Uspješno ste dodali predmet.`);
                }).catch(() => {
                    serverBus.$emit('show-snackbar', false);
                })
            },

            deleteEmployeeSubject() {
                ApiV2.delete(`teacher_subjects/${this.teacherSubjectId}`)
                    .then(() => {
                        this.deleteDialog = false;
                        this.getData();
                        serverBus.$emit('show-snackbar', true);
                    }).catch(() => {
                        serverBus.$emit('show-snackbar', false);
                    });
            },

            getSubjects() {
                ApiV2.get('subjects', {
                    params: {
                    perPage: -1
                    }
                })
                    .then(response => {
                        this.subjects = response.data.data;
                    });
            },

            getUserRoles() {
                this.$axios.post('ostalo/uloga/korisnik/' + this.$route.params.djelatnik_id).then(response => {
                    const roles_user = response.data;

                    let items = [];

                    for (let i = 0; i < roles_user.length; i++) {
                        switch (roles_user[i].organisation_type) {
                            case 'School':
                                items = this.schools;
                                roles_user[i].organisationTypeText = 'Škola';
                                break;
                            case 'Canton':
                                items = this.cantons;
                                roles_user[i].organisationTypeText = 'Županija';
                                break;
                            case 'Everything':
                                roles_user[i].organisationTypeText = 'Pristup svemu';
                                break;
                            default:
                                this.dropdownItems = [];
                        }

                        for (let j = 0; j < items.length; j++) {
                            if (items[j].value === roles_user[i].organisation_id) {
                                roles_user[i].modelText = items[j].text;
                                break;
                            }
                        }
                    }
                    this.roles_user = roles_user;
                });
            },

            getData() {
              if(!this.logged_user) {
                this.$axios.post(this.$getTable() + '')
                    .then(response => {
                      // console.log(response.data)
                      this.userModelRoles = response.data.model_has_roles;
                      this.user = response.data
                      this.optimizeData(response.data)
                    });
              } else {
                this.user = this.$getUser()
                this.optimizeData(this.$getUser())
              }
            },

            optimizeData(employeeData) {
                this.first_name = employeeData.first_name;
                this.last_name = employeeData.last_name;
                this.has_identity = employeeData.has_identity;
                this.email = employeeData.email_private
                let spol = ''
                let nacionalnost = ''
                if (employeeData.sex == 'm') {
                    spol = 'Muško'
                    if (employeeData.nationality == 'hrvat') {
                        nacionalnost = 'Hrvat'
                    } else if (employeeData.nationality == 'srbin') {
                        nacionalnost = 'Srbin'
                    } else if (employeeData.nationality == 'bošnjak') {
                        nacionalnost = 'Bošnjak'
                    } else {
                        nacionalnost = ''
                    }
                } else if (employeeData.sex == 'z') {
                    spol = 'Žensko'
                    if (employeeData.nationality == 'hrvat') {
                        nacionalnost = 'Hrvatica'
                    } else if (employeeData.nationality == 'srbin') {
                        nacionalnost = 'Srpkinja'
                    } else if (employeeData.nationality == 'bosnjak') {
                        nacionalnost = 'Bošnjak'
                    } else {
                        nacionalnost = ''
                    }
                } else {
                    spol = '-'
                    nacionalnost = employeeData.nationality
                }
                this.employeeInfo = {
                    'Ime': employeeData.first_name,
                    'Prezime': employeeData.last_name,
                    'JMBG': employeeData.jmbg,
                    'Datum rođenja': employeeData.date_of_birth,
                    'Mjesto rođenja': employeeData.birth_place,
                    'Država rođenja': this.birthCountry?.text,
                    'Adresa': employeeData.address,
                    'Spol': spol,
                    'E-mail': employeeData.email_private,
                    'Službeni e-mail': employeeData.email,
                    'Telefon': employeeData.phone,
                    'Nacionalnost': nacionalnost,
                    'eduID': employeeData.aai_email
                }
            },

            deleteItem() {
                serverBus.$emit('show-delete-item-dialog', 'djelatnik', {id: this.$route.params.djelatnik_id});
            },
        },

        beforeDestroy() {
            serverBus.$off('show-employee-add-form');
        },
    }
</script>

<style>
    .fix-element {
        position: -webkit-sticky;
        position: sticky;
        top: 5rem;
        align-self: flex-start;
    }

    .custom-btn-red {
        border: 1px rgba(255, 0, 0, 0.20) solid !important;
        border-radius: 5px;
    }

    .custom-btn-blue {
        border: 1px rgba(8, 71, 118, 0.20) solid !important;
        border-radius: 5px;
    }
</style>